
<template>
    <el-header>
        <div class="left">
            <el-icon @click="handleCollapsed">
                <Menu />
            </el-icon>
            <span style="margin-left:10px;">推广达人管理系统</span>
        </div>
        <div class="right">

            <span>欢迎 {{ adminName }} 回来</span>
            <el-dropdown>
                <span class="el-dropdown-link">
                    <el-icon :size="30" color="white">
                        <user />
                    </el-icon>
                </span>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="handleCenter">个人中心</el-dropdown-item>
                        <el-dropdown-item @click="handleLogout">退出</el-dropdown-item>

                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>
    </el-header>
</template>
<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import {useRouter} from 'vue-router'
import { Menu ,User} from "@element-plus/icons-vue";
const store = useStore();
const router = useRouter()
const adminName = computed(() => store.state.userInfo.phone || "管理员");
const handleCollapsed = () => {
  store.commit("changeCollapsed");
};

const handleCenter = ()=>{
    router.push("/center")
}

const handleLogout = async ()=>{
    localStorage.removeItem("adtoken")
    store.commit("clearUserInfo")
    store.commit("changeGetterRouter", false)
    await router.replace({ name: "login" })
}
</script>

<style lang="scss" scoped>
.el-header{
    color:white;
    width:100%;
    height: 60px;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.left,.right{
    display: flex;
}

.left{
    i{
        margin:auto;
        cursor: pointer;
    }
}
.right{
    .el-dropdown{
        margin:auto;
    }
}
</style>
